import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import { Notification } from '../../../Constant';

const socket = io("https://homesnappro-production.up.railway.app", {
  transports: ['websocket'],
});

const Notificationbar = () => {
  const [notificationDropDown, setNotificationDropDown] = useState(false);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    // Listen for new orders from the socket.io server
    socket.on('newOrder', (orderDetails) => {
      setOrders((prevOrders) => [orderDetails, ...prevOrders]);
    });

    return () => {
      socket.off('newOrder');
    };
  }, []);

  return (
    <li className='onhover-dropdown'>
      <div className='notification-box' onClick={() => setNotificationDropDown(!notificationDropDown)}>
        <SvgIcon iconId='notification' />
        <span className='badge rounded-pill badge-secondary'>{orders.length}</span>
      </div>
      <div className={`notification-dropdown onhover-show-div ${notificationDropDown ? 'active' : ''}`}>
        <h6 className='f-18 mb-0 dropdown-title'>{Notification}</h6>
        <ul>
          {orders.length === 0 && (
            <li className='b-l-primary border-4'>
              <p>No new orders</p>
            </li>
          )}
          {orders.map((order, index) => (
            <li key={index} className='b-l-primary border-4'>
              <p>Order Number: <span className='font-danger'>{order.orderNumber}</span></p>
              <p>Order Date: <span className='font-primary'>{order.orderDate}</span></p>
              <p>Total Amount: <span className='font-success'>${order.totalAmount}</span></p>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};

export default Notificationbar;

// import React, { useState } from 'react';
// import SvgIcon from '../../../Components/Common/Component/SvgIcon';
// import { CHECKALL, DeliveryComplete, DeliveryProcessing, Notification, OrderComplete, TicketsGenerated } from '../../../Constant';

// const Notificationbar = () => {
//   const [notificationDropDown, setNotificationDropDown] = useState(false);

//   return (
//     <li className='onhover-dropdown'>
//       <div className='notification-box' onClick={() => setNotificationDropDown(!notificationDropDown)}>
//         <SvgIcon iconId='notification' />
//         <span className='badge rounded-pill badge-secondary'>4</span>
//       </div>
//       <div className={`notification-dropdown onhover-show-div ${notificationDropDown ? 'active' : ''}`}>
//         <h6 className='f-18 mb-0 dropdown-title'>{Notification}</h6>
//         <ul>
//           <li className='b-l-primary border-4'>
//             <p>
//               {"Last Transaction "} <span className='font-danger'>{'10 min ago'}</span>
//             </p>
//           </li>
          
//         </ul>
//       </div>
//     </li>
//   );
// };

// export default Notificationbar;
